import { render, staticRenderFns } from "./NoLogin.vue?vue&type=template&id=8b5af3ae"
import script from "./NoLogin.vue?vue&type=script&lang=js"
export * from "./NoLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports